<script>
import VClamp from 'vue-clamp';

export default {
    name: 'CpSocialFeedRacePost',
    components: {
        CpImage: require('../../image').default,
        CpBaseSvgIcon: require('../../base-svg-icon').default,
        CpStateIcon: require('../icons/state-icon').default,
        WhiteHouseIcon: require('../icons/white-house').default,
        CpSocialShareDialog: require('../../dialogs/social-share').default,
        UsaFlagIcon: require('../icons/usa-flag').default,
        LikeActionButton: require('../actions/like-action-button').default,
        CpLikesProfiles: require('../../likes/likes-profiles').default,
        CpDialog: require('../../dialog').default,
        CpButtonLink: require('../../button-link').default,
        CommentActionButton: require('../actions/comment-action-button').default,
        CpCommentsPost: require('../../comments/box-comments').default,
        CpGrid: require('../../grid').default,
        CpGridItem: require('../../grid-item').default,
        VClamp,
        CpDialogAuthForm: require('../../auth-form/dialog-auth-form').default,
        CpCardHeaderReactions: require('../../components/CardHeaderReactions').default,
    },
    directives: {
        marginTop: require('../../directives/margins').marginTop,
    },
    data() {
        return {
            showLikesModal: false,
            showComments: true,
            comments_count: this.race.comments_count,
            showAuthModal: false,
        };
    },
    props: {
        race: { type: Object, default: () => {} },
        explore: Boolean,
        forShare: Boolean, //Is shared in explore
    },
    methods: {
        handleLikesModal() {
            this.showLikesModal = !this.showLikesModal;
        },
        handleCountLikes(value) {
            if (value) {
                this.race.likes_count = this.race.likes_count + 1;
            } else {
                this.race.likes_count = this.race.likes_count - 1;
            }
        },
        handleComments() {
            if (!this.authUser) {
                this.showAuthModal = true;
            } else {
                this.handleShowComments();
            }
        },
        setCommentsCount(action) {
            action == 'remove' ? this.comments_count-- : this.comments_count++;
        },
        profile(slug) {
            return '/profile/' + slug;
        },
        handleCloseButton() {
            this.showAuthModal = false;
        },
        handleShowComments() {
            this.showComments = !this.showComments;
        },
    },
    computed: {
        randomGradient() {
            const colorArray = ['blue', 'green', 'purple', 'pink', 'orange', 'dark-blue', 'black'];
            const randomIndex = Math.floor(Math.random() * Math.floor(8));
            return colorArray[randomIndex];
        },
        authUser() {
            return this.$root.authUser;
        },
        countCandidates() {
            return this.race.candidates.length;
        },
    },
};
</script>

<template>
    <div class="social-feed-post-wrapper">
        <!-- TO DO: uncomment this when we implement the new feed logic -->
        <!-- <div v-if="explore && race.last_activity" style="display: flex">
            <CpCardHeaderReactions :post="race.last_activity" />
        </div>
        <hr v-if="explore && race.last_activity" class="search-results__tick_action" /> -->

        <div class="social-feed-post-profile-wrapper">
            <div class="details-wrapper">
                <span class="profile-img social-feed-default-img">
                    <cp-base-svg-icon
                        :width="$root.isMobile ? 36 : 30"
                        :height="$root.isMobile ? 36 : 30"
                        :viewBox="'0 0 2.031 1.72125'"
                        :icon-color="'currentColor'"
                        :stroke-color="'none'"
                    >
                        <usa-flag-icon />
                    </cp-base-svg-icon>
                </span>
            </div>
            <div class="details-wrapper">
                <span class="profile-name">
                    <a :href="race.permalink">{{ race.name }}</a>
                </span>
                <span class="post-time">Election</span>
            </div>
        </div>
        <h3 class="social-feed-post-title">{{ race.seat }}</h3>

        <div class="social-feed-post-img-placeholder" :class="randomGradient">
            <cp-grid stretch-content align="center" v-if="race.candidates.length" class="candidates-box">
                <cp-grid-item
                    :span="countCandidates == 4 ? 6 : countCandidates <= 3 ? 12 / countCandidates : 4"
                    v-for="candidate in race.candidates"
                    :key="candidate.id"
                    class="candidate-profile"
                >
                    <v-clamp :max-lines="1" class="candidate-name">{{ candidate.name }}</v-clamp
                    ><cp-image :src="candidate.image" alt="" width="100%" circular border></cp-image>
                </cp-grid-item>
                <cp-grid-item :span="12" v-if="race.more_candidates">
                    <h3 class="more-candidates">And More...</h3>
                </cp-grid-item>
            </cp-grid>
            <div v-else style="width: 100%">
                <cp-state-icon v-if="!!race.state" :american-state="race.state" />
                <white-house-icon v-else />
            </div>
        </div>

        <div v-if="!forShare" style="margin-top: 10px !important">
            <span v-if="race.likes_count > 0" class="content-1" style="cursor: pointer" @click="handleLikesModal">
                {{ race.likes_count }}
                {{ race.likes_count == 1 ? 'Like' : 'Likes' }}
            </span>
            <span v-if="comments_count > 0" class="content-1" style="float: right; cursor: pointer" @click="handleComments">
                {{ comments_count }}
                {{ comments_count == 1 ? 'Comment' : 'Comments' }}
            </span>
        </div>

        <cp-dialog v-if="showLikesModal">
            <cp-likes-profiles :count-likes="race.likes_count" :id="race.id" :type="'races'" @close="handleLikesModal"></cp-likes-profiles>
        </cp-dialog>

        <div v-if="!forShare" class="social-feed-post-actions">
            <div class="post-action-button like">
                <like-action-button type="races" :id="race.id" :liked="race.liked" :onSuccess="handleCountLikes" />
            </div>
            <div class="post-action-button comment">
                <comment-action-button :showComments="handleComments" />
            </div>
            <div class="post-action-button share">
                <cp-social-share-dialog
                    class="feed"
                    :allow-share-feed="true"
                    share-category="Election"
                    :type="'elections'"
                    :post="race"
                    share-button-class="button--noborder"
                    :url="race.permalink"
                    title="Election found via CrowdBlue, the  Social Network For Politics"
                    :description="`Wanted to share this election I found on CrowdBlue, the Social Network for Politics.`"
                    quote
                    hashtags="crowdBlue,politics,crowdfunding"
                    twitter-user="crowdblue"
                    :explore="explore"
                ></cp-social-share-dialog>
            </div>
        </div>

        <cp-comments-post v-if="showComments && !forShare" :id="race.id" :type="'races'" :setCount="setCommentsCount"> </cp-comments-post>
        <cp-dialog-auth-form v-if="showAuthModal" :handleCloseButton="handleCloseButton" showSignUp :callback-action="handleShowComments" />
    </div>
</template>

<style>
.search-results__tick_action {
    color: #cacaca;
    width: 50px !important;
    margin-right: auto;
}
.candidates-box {
    width: 95%;
    text-align: center;
}
.candidate-profile {
    display: block;
}
.candidate-name {
    color: white;
    font-size: 1.17em;
    font-weight: bold;
    margin: 10px 0;
}
.more-candidates {
    color: white;
    margin: 0;
}
.search-results__tick {
    color: #cacaca;
    width: 50px;
}
div.social-feed-post-img-placeholder.pink {
    background: linear-gradient(90deg, #d53369 0%, #daae51 100%);
}
div.social-feed-post-img-placeholder.orange {
    background: linear-gradient(to right, #f83600, #fe8c00);
}

div.social-feed-post-img-placeholder.blue {
    background: linear-gradient(90deg, #1cb5e0 0%, #000851 100%);
}
div.social-feed-post-img-placeholder.dark-blue {
    background: linear-gradient(90deg, #4b6cb7 0%, #182848 100%);
}

div.social-feed-post-img-placeholder.green {
    background: #0eb45b;
    background: var(--green);
    background: linear-gradient(to right, #0eb45b, #57cd8e);
    background: linear-gradient(to right, var(--green), var(--green-lighter));
}
div.social-feed-post-img-placeholder.purple {
    background: linear-gradient(to right, #5e18af, rgba(31, 38, 103, 0.9));
}

div.social-feed-post-img-placeholder.black {
    background-color: #000000;
    background: linear-gradient(to right, #000000, #7f8c8d);
}
</style>
